import { render } from "./clipsList.vue?vue&type=template&id=b683cdbc&scoped=true"
import script from "./clipsList.vue?vue&type=script&lang=js"
export * from "./clipsList.vue?vue&type=script&lang=js"

import "./clipsList.vue?vue&type=style&index=0&id=b683cdbc&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b683cdbc"]])

export default __exports__